import styled from 'styled-components';

export const SpinnerWrapperStyled = styled.div`
  height: 30vh;
  width: 100%;
`;
